module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-30",
		"endpointPrefix": "cognito-identity",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityService",
		"uid": "cognito-identity-2014-06-30"
	},
	"operations": {
		"CreateIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"shape": "Sf"
			}
		},
		"DeleteIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityIdsToDelete"
				],
				"members": {
					"IdentityIdsToDelete": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedIdentityIds": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"ErrorCode": {}
							}
						}
					}
				}
			}
		},
		"DeleteIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			}
		},
		"DescribeIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {}
				}
			},
			"output": {
				"shape": "Sq"
			}
		},
		"DescribeIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"shape": "Sf"
			}
		},
		"GetCredentialsForIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					},
					"CustomRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Credentials": {
						"type": "structure",
						"members": {
							"AccessKeyId": {},
							"SecretKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetId": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"AccountId": {},
					"IdentityPoolId": {},
					"Logins": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"GetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S17"
					},
					"RoleMappings": {
						"shape": "S19"
					}
				}
			}
		},
		"GetOpenIdToken": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"GetOpenIdTokenForDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Logins"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					},
					"TokenDuration": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"ListIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"MaxResults"
				],
				"members": {
					"IdentityPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"HideDisabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Identities": {
						"type": "list",
						"member": {
							"shape": "Sq"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityPoolId": {},
								"IdentityPoolName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"LookupDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"DeveloperUserIdentifier": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DeveloperUserIdentifierList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"MergeDeveloperIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"SourceUserIdentifier",
					"DestinationUserIdentifier",
					"DeveloperProviderName",
					"IdentityPoolId"
				],
				"members": {
					"SourceUserIdentifier": {},
					"DestinationUserIdentifier": {},
					"DeveloperProviderName": {},
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"SetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Roles"
				],
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S17"
					},
					"RoleMappings": {
						"shape": "S19"
					}
				}
			}
		},
		"UnlinkDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"IdentityPoolId",
					"DeveloperProviderName",
					"DeveloperUserIdentifier"
				],
				"members": {
					"IdentityId": {},
					"IdentityPoolId": {},
					"DeveloperProviderName": {},
					"DeveloperUserIdentifier": {}
				}
			}
		},
		"UnlinkIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"Logins",
					"LoginsToRemove"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					},
					"LoginsToRemove": {
						"shape": "Sr"
					}
				}
			}
		},
		"UpdateIdentityPool": {
			"input": {
				"shape": "Sf"
			},
			"output": {
				"shape": "Sf"
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ClientId": {}
				}
			}
		},
		"Se": {
			"type": "list",
			"member": {}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"IdentityPoolId",
				"IdentityPoolName",
				"AllowUnauthenticatedIdentities"
			],
			"members": {
				"IdentityPoolId": {},
				"IdentityPoolName": {},
				"AllowUnauthenticatedIdentities": {
					"type": "boolean"
				},
				"SupportedLoginProviders": {
					"shape": "S4"
				},
				"DeveloperProviderName": {},
				"OpenIdConnectProviderARNs": {
					"shape": "S8"
				},
				"CognitoIdentityProviders": {
					"shape": "Sa"
				},
				"SamlProviderARNs": {
					"shape": "Se"
				}
			}
		},
		"Sq": {
			"type": "structure",
			"members": {
				"IdentityId": {},
				"Logins": {
					"shape": "Sr"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"Sr": {
			"type": "list",
			"member": {}
		},
		"Sv": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S17": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S19": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"AmbiguousRoleResolution": {},
					"RulesConfiguration": {
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Claim",
										"MatchType",
										"Value",
										"RoleARN"
									],
									"members": {
										"Claim": {},
										"MatchType": {},
										"Value": {},
										"RoleARN": {}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-identity-2014-06-30.min.json
// module id = 659
// module chunks = 2